import { render, staticRenderFns } from "./UserAvatarWithName.vue?vue&type=template&id=b19a8be4&"
import script from "./UserAvatarWithName.vue?vue&type=script&lang=js&"
export * from "./UserAvatarWithName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports